import { isURL } from '@/assets/js/validate.js'
export default {
  computed: {
    // 矩阵填空 v-model
    getMatrixInput() {
      return function (rowItem, col) {
        let valueItem = this.rowData.items.find(item => {
          return item.rowId === rowItem.row_id && item.colId === col.id
        })
        let model = valueItem ? valueItem.value : ''
        return { model }
      }
    },
    // 矩阵下拉 v-model
    getMatrixSelect() {
      return function (rowItem, col) {
        const cells = this.rowData.questionDetails.issue.cells // 选项
        const modelId = this.rowData.items.find(item => {
          return item.rowId === rowItem.row_id && item.colId === col.id
        })
        const options = cells.find(it => {
          return it.col_id === col.id
        }).items
        let model = modelId ? modelId.optionId : ''
        return { model, options }
      }
    }
  },
  methods: {
    audioUrlsFun(data) {
      if (data.audioFiles) {
        for (let s = 0; s < data.audioFiles.length; s++) {
          //   console.log(data.audioFiles[s]);
          this.audioUrls.push({
            text: '全程',
            id: data.id,
            mediaUrl: data.audioFiles[s],
            name: `${data.surveyTitle}音频${s + 1}${data.id}`,
            imgArr: this._getDownloadUrl(data.audioFiles[s]),
            dltext: this._getDownloadUrl(data.audioFiles[s], 'isAudio', `${data.surveyTitle}音频${s + 1}${data.id}`), // isAudio 20200616 hack 音频用新的接口
            rate: 1.0 // 播放速率
          })
          // 提交数据初始化
          this.audioFilesArr.push(data.audioFiles[s])
        }
      }
    },
    videoUrlsFun(data) {
      if (data.videoFiles) {
        for (let s = 0; s < data.videoFiles.length; s++) {
          this.videoUrls.push({
            text: '全程',
            id: data.id,
            mediaUrl: data.videoFiles[s],
            name: `${data.surveyTitle}视频${s + 1}${data.id}`,
            // imgArr: window.location.origin + data.videoFiles[s]
            imgArr: this._getDownloadUrl(data.videoFiles[s])
          })
          // 提交数据初始化
          this.videoFilesArr.push(data.videoFiles[s])
        }
      }
    },
    // 全局图片
    picGlobalFun(data) {
      if (Array.isArray(data.imageFiles)) {
        for (let s = 0; s < data.imageFiles.length; s++) {
          this.imageGlobalUrls.push({
            text: '全程',
            id: data.id,
            mediaUrl: data.imageFiles[s],
            name: data.surveyTitle + '图片' + data.id,
            imgArr: this._getDownloadUrl(data.imageFiles[s])
          })
          // 提交数据初始化
          this.imageFilesArr.push(data.imageFiles[s])
        }
      }
    },
    // 问卷图片
    picSurveyFun(data) {
      var a = []
      if (data.answerContent) {
        for (let index = 0; index < data.answerContent.length; index++) {
          let tempData = data.answerContent[index]
          if (tempData.photoFiles && tempData.photoFiles.length > 0) {
            var v = []
            for (let i = 0; i < tempData.photoFiles.length; i++) {
              v.push(this._getDownloadUrl(tempData.photoFiles[i]))
            }
            a.push({
              id: data.id,
              text: '问题' + (index + 1) + '：' + tempData.questionDetails.content.text,
              name: data.surveyTitle + '图片' + data.id,
              imgArr: v
            })
          }
        }
      }
      this.imageSurveyUrlArr = a
    },
    signFun(data) {
      var a = []
      if (data.answerContent) {
        for (let index = 0; index < data.answerContent.length; index++) {
          let tempData = data.answerContent[index]
          if (tempData.questionType === 14) {
            var v = []
            if (tempData.items) {
              // 兼容非必答题
              for (let i = 0; i < tempData.items.length; i++) {
                if (tempData.items[i].value) {
                  if (tempData.items[i].value.indexOf('=') != -1) {
                    v.push(this._getDownloadUrl(tempData.items[i].value.split('=')[1]))
                  } else {
                    v.push(this._getDownloadUrl(tempData.items[i].value))
                  }
                } else {
                  v.push('')
                }
              }
            }
            a.push({
              name:
                '问题' +
                (index + 1) +
                '：' +
                (tempData.questionDetails.content.richText || tempData.questionDetails.content.text),
              //编辑时加的图片
              image: tempData.questionDetails.content.image,
              //答题时或在审核页上传的图片
              url: tempData.activePhotoFiles,
              imgArr: v,
              tempData: tempData
            })
          }
        }
      }
      this.signUrlArr = a
    },
    _getDownloadUrl(downUrl = '', flag, fileName) {
      let url = window.location.origin
      if (downUrl.includes('admin/sys-file')) {
        url = url + downUrl
      } else if (flag === 'isAudio') {
        url = url + '/fill/api/v1/downloadWithName?fileName=' + downUrl + '&downLoadName=' + fileName
      } else {
        // 如果是 http(s) 开头
        if (isURL(downUrl)) {
          url = downUrl
        } else {
          if (downUrl.startsWith('/')) {
            downUrl = downUrl.slice(1)
          }
          url = url + '/fill/api/v1/download?fileName=' + downUrl
        }
      }
      return url
    },
    returnFloat(data) {
      if (data == null) {
        return 0
      } else {
        let value = Math.round(parseFloat(data) * 100) / 100
        let s = value.toString().split('.')
        if (s.length == 1) {
          value = value.toString() + '.00'
          return value
        }
        if (s.length > 1) {
          if (s[1].length < 2) {
            value = value.toString() + '0'
          }
          return value
        }
      }
    }
  }
}
